export default function findAllParents(rowData, rowKey) {
  var parents = [];

  if (!rowData) {
    return parents;
  }

  function findParent(data) {
    if (data) {
      parents.push(data[rowKey]);

      if (data._parent) {
        findParent(data._parent);
      }
    }
  }

  findParent(rowData._parent);
  return parents;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/utils/findAllParents.js
// module id = 2427
// module chunks = 35